import styled from "styled-components";

export const AccordionContainer = styled.div`
  width: 100%;
  margin: 0 auto;
`;

export const AccordionItemContainer = styled.div`
  border: 1px solid #ccc;
  border-radius: 4px;
  margin-bottom: 8px;
  overflow: hidden;
`;

export const AccordionItemHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  background-color: #f5f5f5;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: #e0e0e0;
  }
`;

export const AccordionItemContent = styled.div<{ isOpen: boolean }>`
  padding: ${({ isOpen }) => (isOpen ? "16px" : "0 16px")};
  background-color: #fff;
  max-height: ${({ isOpen }) => (isOpen ? "500px" : "0")};
  overflow: hidden;
  transition: all 0.3s ease-out;
`;
